<div>
  <span>
    Content: <strong>I`m a component nested in a Collapse Item</strong> and this is a parameter received from caller component:
    <strong>{{ data.term }}</strong>
  </span>

  <div class="row m-t-20">
    <div class="col-12">
      <ng-container
        *ngIf="{
          isLoading: isLoading$ | async,
        } as content"
      >
        <div class="content-box">
          @if (content.isLoading) {
            <local-loader></local-loader>
          } @else {
            <img class="w-100" src="https://placehold.co/1920x400" alt="" />
          }
        </div>
      </ng-container>
    </div>
  </div>
</div>
